import script from "./ListBadgesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListBadgesView.vue?vue&type=script&setup=true&lang=js"

import "./ListBadgesView.vue?vue&type=style&index=0&id=f7a14bb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a14bb6"]])

export default __exports__